module.exports = __webpack_public_path__ + "img/c6.26edbdc0.webp";